"use client";
import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import right from "../../../../public/updated-home/car-service/special-event/Right.svg";
import left from "../../../../public/updated-home/car-service/special-event/Left.svg";
import Image from "next/image";
import Mydata from "@/app/data/Servies/special_event.json";

function SliderIndicator({ index, activeIndex, onClick }) {
  return (
    <span
      onClick={() => onClick(index)}
      className={`h-2 w-2 bg-gray-500 rounded-full mx-1 display-desktop  cursor-pointer ${
        index === activeIndex ? "bg-[#D5AF34]" : "red"
      }`}
    />
  );
}

function Vision() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const data = Mydata[4].third_trusted;

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < data.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data.length - 1
    );
  };

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    // Auto slide every 5 seconds
    const interval = setInterval(() => {
      handleNext();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);

  return (
    <div className="bg-[#2b3252] ">
      <div className="mx-auto max-w-7xl  pt-12"></div>

      <div className=" grid grid-cols-12 mb-10 pb-12">
        <div className="col-span-1 display flex items-center justify-center">
          {" "}
          <div className="col-span-1">
            <Image
              src={left}
              height={20}
              width={20}
              className="text-4xl text-[#D5AF34] cursor-pointer mr-4"
              onClick={handlePrev}
              title="left arrow"
              alt="left arrow"
            />
          </div>
        </div>

        <div className=" px-6 col-span-12 sm:col-span-10 md:col-span-10 lg:col-span-10 ">
          <div className=" relative ">
            <div
              style={{ background: "rgba(245, 245, 245, 1)" }}
              className="mx-auto  px-[16px] visiontop  rounded-2xl lg:pb-10  max-w-7xl grid grid-cols-5  lg:gap-10  xl:px-10 relative"
            >
              <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2 ">
                <Image
                  src={data[currentIndex].image}
                  alt={data[currentIndex].alt}
                  title={data[currentIndex].tle}
                  width={980}
                  height={240}
                />
              </div>

              <div
                id="visionh2"
                className="col-span-12  sm:col-span-12 md:col-span-12  lg:col-span-3         mb-10  sm:mb-6 md:mb-5 xl:mb-0  "
              >
                <div className="flex gap-2">
                  <Image
                    id="visionh2"
                    src={data[currentIndex].icons}
                    width={30}
                    height={30}
                    title="left arrow"
                    alt="left arrow"
                  />
                  <h2 id="visionh2" className="text-3xl  secondary font-bold">
                    {data[currentIndex].title}
                  </h2>
                </div>
                {data[currentIndex].des.map((item, index) => (
                  <div key={index} className="flex">
                    <p className="text-lg font-bold pt-2 text-[#2b3252]">
                      {item.subdes}
                      <span className="updatedparapremu  ml-1">{item.des}</span>
                    </p>
                    <p className=""></p>
                  </div>
                ))}
              </div>

              {/* Indicators */}
              <div className="absolute bottom-4 left-0 right-0 flex justify-center">
                {data.map((_, index) => (
                  <SliderIndicator
                    key={index}
                    index={index}
                    activeIndex={currentIndex}
                    onClick={handleIndicatorClick}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-span-1 display flex items-center justify-center ">
          <div className="col-span-1 ">
            <Image
              src={right}
              height={20}
              width={20}
              className="text-4xl text-[#D5AF34] cursor-pointer"
              onClick={handleNext}
              title="right arrow"
              alt="right arrow"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vision;
